import { render } from "./IconShower.vue?vue&type=template&id=780ef8a6"
import script from "./IconShower.vue?vue&type=script&lang=js"
export * from "./IconShower.vue?vue&type=script&lang=js"
script.render = render

export default script